export const Packages = () => {
  return (
    <div className="container" style={{ paddingTop: '24px' }}>
      <h1>Пакеты услуг</h1>
      <p>Готовые пакеты решений для бизнеса...</p>
    </div>
  );
};